export const EURO1 = 1072;
export const EURO2 = 1073;
export const EURO3 = 1074;
export const EURO4 = 1075;
export const EURO5 = 1076;
export const EURO6 = 3532;
